import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import H5App from './H5App';
import store from './store/index'
import {Provider} from 'react-redux'




const root = ReactDOM.createRoot(document.getElementById('root'));
window.addEventListener('resize',function(e){
    getApp()
})
const getApp =() =>{
    if(window.innerWidth>=801){
        root.render(
            <React.StrictMode>
                <Provider store={store}>
                    <App />
                </Provider>
            </React.StrictMode>
        );
    }else{
        root.render(
            <React.StrictMode>
                <Provider store={store}>
                    <H5App />
                </Provider>
            </React.StrictMode>
        );
    }
}
getApp()


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
